export enum ProductStatusEnum {
    Pendiente = 1,
    EnProceso = 2,
    Lista = 3,
    Modificada = 4
}
